import React from 'react';
import Header from '../components/Header';
import CardList from '../components/CardList';

const AddFindPage = () => {
    return (
        <div>
            <Header text={'Add a find'} />
            <CardList />
        </div>
    );
};

export default AddFindPage;
